import { useEffect, useState } from "react";
import ajaxAccounting from "../../util/remote/ajaxAccounting";
import SystemModal from "../Common/SystemModal";
import numberToWords from "number-to-words";
const JournalPrintingWzStatement = ({ folioID, type, reff }) => {
  console.log(folioID);
  const [vouchers, setVouchers] = useState([]);
  const [project, setProject] = useState("");
  const [folio, setFolio] = useState("");
  const [folio_sum, setFolioSum] = useState({});
  const [folio_vat, setFolioVat] = useState({});
  const [folio_sum_v, setFolioSumV] = useState({});
  const [statement, setStatement] = useState([]);
  /** ---------------------
   *  Fetching functions
   *  --------------------- */
  const getStatement = async () => {
    const data = { reff };
    const server_response = await ajaxAccounting.getsupplierInvoice_statement(
      data
    );
    if (server_response.status === "OK") {
      setStatement(server_response.details);
    }
  };
  const getPaymentVoucher = async () => {
    const data = { folioID, type };
    const server_response = await ajaxAccounting.getFolioVouchersList(data);
    if (server_response.status === "OK") {
      setVouchers(server_response.details.data_list || []);
      setProject(server_response.details.project || "");
      setFolio(server_response.details.folio || "");
      setFolioSum(server_response.details.folio_sum || {});
      setFolioSumV(server_response.details.folio_sum_v || {});
      setFolioVat(server_response.details.folio_vat || {});
    } else {
      setVouchers([]);
    }
  };
  useEffect(() => {
    getPaymentVoucher();
    getStatement();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  /** ---------------------
   *  Helpers
   *  --------------------- */
  const amountToWords = (amount) => {
    const words = numberToWords.toWords(amount || 0);
    return words.charAt(0).toUpperCase() + words.slice(1);
  };
  const Print = (e, controls) => {
    e.preventDefault();
    const printContents = document.getElementById("printablediv").innerHTML;
    const originalTitle = document.title;
    const newWindow = window.open("", "_blank");
    newWindow.document.open();
    newWindow.document.write(`
      <html>
        <head>
          <title>${originalTitle} - Print</title>
        </head>
        <body style="font-family: Arial, sans-serif; margin: 0; padding: .5cm; width: 21cm; height: 29.7cm;">
          ${printContents}
        </body>
      </html>
    `);
    newWindow.document.close();
    newWindow.focus();
    newWindow.print();
    newWindow.onafterprint = () => {
      controls.close();
      newWindow.close();
    };
  };
  const RenderFooter = (controls) => (
    <>
      <button
        className="btn ripple btn-dark"
        type="button"
        onClick={controls.close}
      >
        Close
      </button>
      <button
        className="btn ripple btn-dark"
        type="button"
        onClick={(e) => Print(e, controls)}
      >
        Print
      </button>
    </>
  );
  /** ---------------------
   *  JSX
   *  --------------------- */
  return (
    <SystemModal
      title="Transaction Printing"
      id="model-new-ledger"
      size="lg"
      footer={RenderFooter}
    >
      <div id="printablediv">
        <div
          style={{
            fontFamily: "Arial, sans-serif",
            backgroundImage: `url(${process.env.PUBLIC_URL}/template/assets/images/doc_back.png)`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            width: "21cm",
            padding: "2cm",
          }}
        >
          {/* Header */}
          <div
            className="row"
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "10px",
            }}
          >
            {/* Company details */}
            <div
              className="company-details"
              style={{
                width: "80%",
                lineHeight: "6px",
              }}
            >
              <h3 align="left">BERICOT AFRICA LIMITED</h3>
              <p style={{ fontSize: "14px" }} align="left">
                P.O.BOX 28775 KAMPALA
              </p>
              <p style={{ fontSize: "14px" }} align="left">
                PLOT 79B MAKAMBA ROAD
              </p>
              <p style={{ fontSize: "14px" }} align="left">
                TEL : +256701666160
              </p>
              <p style={{ fontSize: "14px" }} align="left">
                EMAIL : info@bericot.africa
              </p>
              <div align="center">
                Journal NO: <span className="text-info">{folio}</span>
              </div>
              <div align="left" style={{ marginTop: "10px" }}>
                <p>
                  Ledger Credited:
                  <span style={{ color: "red" }}>
                    {vouchers?.[0]?.ledgerID_credited?.Ledger_name || ""}
                  </span>
                </p>
              </div>
            </div>
            {/* Company Logo */}
            <div style={{ width: "20%" }}>
              <img
                style={{ height: "100px", width: "200px" }}
                src={`${process.env.PUBLIC_URL}/template/assets/images/bricote_logo.png`}
                alt="Logo"
              />
            </div>
          </div>
          {/* Items Table */}
          <div
            style={{
              width: "100%",
              borderCollapse: "collapse",
              border: "2px groove grey",
            }}
          >
            <table
              style={{
                width: "100%",
                marginBottom: "10px",
                tableLayout: "fixed",
              }}
            >
              <thead>
                <tr>
                  {[
                    "No",
                    "Ledger",
                    "Details",
                    "Cost Center",
                    "Amount",
                    "Date",
                  ].map((h, i) => (
                    <th
                      key={i}
                      style={{
                        backgroundColor: "#4A00E0",
                        color: "#fff",
                        padding: "10px",
                        textAlign: "left",
                        height: "20px",
                      }}
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {Array.isArray(vouchers) &&
                  vouchers.map((item, key) => (
                    <tr key={key} style={{ height: "20px" }}>
                      <td style={tdStyle}>{key + 1}</td>
                      <td style={tdStyle}>
                        {item.ledgerID_debited?.Ledger_name || ""}
                      </td>
                      <td style={tdStyle}>{item.description}</td>
                      <td style={tdStyle}>{item.catID?.item || ""}</td>
                      <td style={tdStyle}>{item.amount?.amount_c || ""}</td>
                      <td style={tdStyle}>{item.date?.date || ""}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          {/* Statement Section */}
          <div style={{ width: "100%", marginTop: "20px" }}>
            <h4 style={{ textAlign: "center" }}>Statement</h4>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                border: "1px solid grey",
                textAlign: "center",
                marginTop: "10px",
              }}
            >
              <thead>
                <tr style={{ backgroundColor: "rgba(200, 200, 200, 0.3)" }}>
                  <th>No</th>
                  <th>Supplier Ref</th>
                  <th>Date</th>
                  <th>Debit (Ugx)</th>
                  <th>Credit (Ugx)</th>
                  <th>Balance (Ugx)</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(statement) && statement.length > 0 ? (
                  statement.map((item, key) => (
                    <tr
                      key={key}
                      style={{ borderBottom: "1px solid grey", height: "30px" }}
                    >
                      <td>{key + 1}</td>
                      <td>{item.supplier_reff}</td>
                      <td>{new Date(item.date).toLocaleDateString()}</td>
                      <td>{item.debit.toLocaleString()}</td>
                      <td>{item.credit.toLocaleString()}</td>
                      <td>{item.balance.toLocaleString()}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={6}
                      style={{ textAlign: "center", padding: "10px" }}
                    >
                      No statement available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {/* Totals */}
          <div style={{ marginTop: "20px" }}>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <div style={{ width: "50%" }}>
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    border: "2px groove grey",
                    textAlign: "center",
                  }}
                >
                  <tbody>
                    <tr style={trStyle}>
                      <td>
                        <b>Amount:</b>
                      </td>
                      <td>Ugx {folio_sum?.folio_sum_c || 0}</td>
                    </tr>
                    <tr style={trStyle}>
                      <td>
                        <b>V.A.T (18%):</b>
                      </td>
                      <td>Ugx {folio_vat?.folio_vat_c || 0}</td>
                    </tr>
                    <tr style={trStyle}>
                      <td>
                        <b>Total Amount:</b>
                      </td>
                      <td>Ugx {folio_sum_v?.folio_sum_v_c || 0}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <hr style={{ border: "1px grey dotted", margin: "10px 0" }} />
            {/* Amount in Words */}
            <div style={{ textAlign: "left", marginTop: "10px" }}>
              <p>
                <b>Amount In Words:</b>{" "}
                <span style={{ color: "grey" }}>
                  <u>
                    {folio_sum_v?.folio_sum_v
                      ? `${amountToWords(folio_sum_v.folio_sum_v)} shillings`
                      : ""}
                  </u>
                </span>
              </p>
            </div>
            {/* Footer Signatures */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: "center",
                marginTop: "10px",
                color: "grey",
              }}
            >
              <div>
                <p>Prepared By: ______________________</p>
                <p>Authorised By: ____________________</p>
              </div>
              <div>
                <p>Received By: ______________________</p>
                <p>Printed on: {new Date().toLocaleDateString()}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SystemModal>
  );
};
/** Table cell styles */
const tdStyle = {
  borderBottom: "1px solid #ddd",
  padding: "10px",
  textAlign: "center",
};
const trStyle = {
  color: "black",
  borderBottom: "1px solid grey",
};
export default JournalPrintingWzStatement;
